import {
  createSlice,
  type PayloadAction,
  type Reducer,
} from '@reduxjs/toolkit';
import type { GameConfig } from '../types/game';

export const GAME_SLICE_KEY = 'game';

export interface GameSliceState {
  gameConfig: GameConfig;
}

const initialState: GameSliceState = {
  gameConfig: {
    id: null,
    gameId: '',
    displayName: '',
    operatorId: '',
    available: false,
    type: 'ROCK_PAPER_SCISSORS',
    videoUrl: '',
    mainMarket: {
      id: '',
      type: '',
      enabled: false,
      layEnabled: false,
      minStake: null,
      maxStake: null,
    },
    mainMarkets: [],
    sideMarkets: [],
    betTimerLimit: 0,
    maxBet: 0,
    maxWin: null,
    imageUrl: null,
    tags: null,
    createdDate: null,
    lastUpdatedDate: null,
    version: 0,
    currencyLimits: [],
    videoEnabled: false,
    layEnabled: false,
  },
};

const gameSlice = createSlice({
  name: GAME_SLICE_KEY,
  initialState,
  reducers: {
    setGameConfig: (state, action: PayloadAction<GameConfig>) => {
      state.gameConfig = action.payload;
    },
    resetGameSlice: () => initialState,
  },
});

const gameReducer = gameSlice.reducer as Reducer;
export default gameReducer;

export const gameSelector = (state: { [GAME_SLICE_KEY]: GameSliceState }) =>
  state[GAME_SLICE_KEY];

export const gameActions = gameSlice.actions;
